import { AxiosResponse } from 'axios'
import { useContext } from '@nuxtjs/composition-api'
import { BRAND_MEDIA_VIEW } from '../../../../config/bitrix-endpoints'
import { NewsListResponse } from '../../../contracts/api/QueryNews/QueryNews.Response'
import { BITRIX_API } from '../../instance'

export async function viewArticle(
  ctx: ReturnType<useContext> | undefined = undefined,
  id: number | undefined = undefined
): Promise<AxiosResponse<NewsListResponse>> {
  const formData = new FormData()
  formData.append('timestamp', String(Date.now()))
  return await BITRIX_API(ctx).post(`${BRAND_MEDIA_VIEW}/${id}`, formData)
}
